






































import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";

@Component
export default class RegWithoutTerminalInfoDialog extends CommonBase {
  @Prop({default: false})
  value!: boolean;

  get opened() {
    return this.value;
  }
  set opened(v: boolean) {
    this.$emit("input", v);
  }

  close() {
    this.opened = false;
  }
}
